import React from 'react'
import { Button } from 'reactstrap'
import { sortCaret } from  '../../../comum/components/Icones'
import UnidadesLiberadasArmadorService from '../../../../services/UnidadesLiberadasArmadorService'
import { observable, toJS } from 'mobx'
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';

export default class UnidadesLiberadasArmadorStore {

    @observable loadingDefault;
    @observable loadingModal;

    @observable modo;

    @observable tableMessage;
    @observable alerta;

    @observable listaArmadores;
    @observable listaArmadoresGrupos;
    @observable listaTiposCntr;
    @observable listaDefault;
    
    @observable armadorSelecionado;
    @observable depotSelecionado;
    @observable qtdDesassociar;
    @observable qtdAssociar;

    @observable salvando;
    @observable loading;

    constructor() {
        this.listaDefault = []
        this.defaultBackup = []

        this.modo = null

        this.alerta = ""

        this.loadingModal = false
        this.loadingDefault = false
    
        this.colunas = this.todasColunas

        this.service = new UnidadesLiberadasArmadorService()

        this.tableMessage = buscaFiltrarVazio

        this.listaArmadores = []
        this.listaArmadoresGrupos = []
        this.listaTiposCntr = []
        
        this.armadorSelecionado = null
        this.depotSelecionado = null;
        this.loading = false
        this.salvando = false
    }

    fecharModalAlerta = () => {
        this.alerta = ""
    }

    listarUnidadesArmadoresTipo = () => {
        this.listaDefault = []
        this.loadingDefault = true;
        this.service.ListarUnidadesLiberadasPorArmador(this.armadorSelecionado ? this.armadorSelecionado.value : null).then(response => {
            if(response && response.data) {
                this.listaDefault = response.data.length > 0 ? response.data.map((itemDefault, index) => {
                    return(
                        {
                            id: itemDefault.Id,
                            isGrupo: itemDefault.GrupoArmId !== null, 
                            armador:{
                                label: itemDefault.ApelidoArmador,
                                value: itemDefault.ArmId
                            },
                            tipoCntr:{
                                label: itemDefault.CdTipoCntr,
                                value: itemDefault.CdTipoCntr
                            },
                            qtd: itemDefault.QtdLiberada,
                            ativo: itemDefault.FlgAtivo === "S"
                        }
                    )
                }) : [];
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingDefault = false)
    }

    salvarListaDefault = () => {
        let listaSalvar = this.listaDefault && this.listaDefault.map(item => {
            if((item.armador !== null 
                && item.armador.value !== null) 
                && (item.tipoCntr !== null 
                && item.tipoCntr.value !== null)){
                if(item.isGrupo) {
                    return({
                            "GrupoArmId": item.armador.value,
                            "ArmId": item.armador.value,
                            "CodTipoCntr": item.tipoCntr.value,
                            "QuantLiberada": item.qtd,
                            "Ativo": item.ativo
                        }
                    )
                } else {
                    return({
                        "GrupoArmId": null,
                        "ArmId": item.armador.value,
                        "CodTipoCntr": item.tipoCntr.value,
                        "QuantLiberada": item.qtd,
                        "Ativo": item.ativo
                    }
                )
                }
            } else {
                return null
            }
        })
        listaSalvar = listaSalvar.filter(item => item !== null)
        this.service.SalvarUnidadesLiberadasArmador(listaSalvar).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso === true) {
                    // mensagem de sucesso
                    this.listarUnidadesArmadoresTipo();
                    
                    this.alerta = "Alterações salvas com sucesso"
                } else {
                    //mensagem de erro
                    this.alerta = response.data.MensagemErro
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => {
            this.loadingModal = false
        })
    }

    listarArmadores = () => {
        this.loading = true
        this.service.ListarArmadores().then(response => {
            if(response && response.data) {
                this.listaArmadoresGrupos = response.data;
                this.listaArmadores = 
                    response.data.map(armador => {
                        return(
                            {
                                label: armador.ApelidoArmador,
                                value: armador.ArmId
                            }
                        )
                    })
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    listarTiposCntr = () => {
        this.loading = true
        this.service.ListarTiposCntr().then(response => {
            if(response && response.data && response.data.length > 0) {
                this.listaTiposCntr = response.data.map(tipoCntr => {
                    return(
                        {
                            label: tipoCntr.CodTipoCntr,
                            value: tipoCntr.CodTipoCntr
                        }
                    )
                })
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    setArmador = (value) => {
        this.armadorSelecionado = value
    }

    setValorDefault = (event, param, item, index) => {
        switch (param) {
            case "armador":
                this.listaDefault[index].armador = event;
                let armador = this.listaArmadoresGrupos.length > 0 && this.listaArmadoresGrupos.filter(item => item.ArmId === event.value);
                this.listaDefault[index].isGrupo = armador.length > 0 && armador[0].FlagIsGrupo === 'S';
                break;
            case "tipoCntr":
                this.listaDefault[index].tipoCntr = event;
                break;
            case "qtd":
                this.listaDefault[index].qtd = event && event.target ? event.target.value : null;
                break;
            case "ativo":
                this.listaDefault[index].ativo = !this.listaDefault[index].ativo;
                break;
        }
    }

    addArmadorNovo = () => {
        this.listaDefault.push(
            {
                id: 0,
                armador:null, 
                tipoCntr:null,
                qtd: null,
                ativo: true,
                isGrupo: false
            }
        )
    }

    excluirUnidadesArmador = (item, index) => {
        if(item.id && item.id > 0){ 
            this.service.ExcluirUnidadesArmadorDepot(item.id).then(response => {
                if(response && response.data) {
                    if(response.data.Sucesso === true) {
                        // mensagem de sucesso
                        this.listaDefault.splice(index,1);
                    } else {
                        //mensagem de erro
                        this.alerta = response.data.MensagemErro
                    }
                }
            }).catch(err => console.error(err)
            ).finally(() => {
                this.loadingModal = false
            })
        } else {
            this.listaDefault.splice(index,1);
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-unidades-liberadas/stores/UnidadesLiberadasArmadorStore.js